import { Logo } from '../components/Logo'
import { Aco } from '../components/Aco';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  NumberData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';

const data = [
  {en: 'Alpha-pinene', ja: 'アルファ-ピネン', value:'0.51%'},
  {en: 'Camphene', ja: 'カンフェン', value:'2.75%'},
  {en: '6-methylhept-5-en-2-one', ja: '6-メチルヘプト-5-エン-2-オン', value:'3.54%'},
  {en: 'Myrcene, dehydro-1,8-cineole', ja: 'ミルセン、デヒドロ-1,8-シネオール', value:'0.21%'},
  {en: 'n-octanal', ja: 'n-オクタナール', value:'0.06%'},
  {en: 'p-cymene', ja: 'p-シメン', value:'0.05%'},
  {en: 'limonene', ja: 'リモネン', value:'0.63%'},
  {en: 'cis-beta-ocimene', ja: 'シス-ベータ-オキシメン', value:'0.54%'},
  {en: 'trans-beta-ocimene', ja: 'トランス-ベータ-オキシメン', value:'0.36%'},
  {en: 'terpinolene', ja: 'テルピノレン', value:'0.11%'},
  {en: 'linalool', ja: 'リナロール', value:'1.88%'},
  {en: 'exo-isocitral', ja: 'エキソ-イソシトラール', value:'0.11%'},
  {en: 'photocitral A', ja: 'フォトシトラール A', value:'0.39%'},
  {en: 'cis-isocitral', ja: 'シス-イソシトラール', value:'0.49%'},
  {en: 'trans-isocitral', ja: 'トランス-イソシトラール', value:'1.06%'},
  {en: 'alpha-terpineol', ja: 'アルファ-テルピネオール', value:'0.28%'},
  {en: 'n-decanal', ja: 'n-デカナール', value:'0.09%'},
  {en: 'nerol', ja: 'ネロール', value:'0.21%'},
  {en: 'neral', ja: 'ネラール', value:'9.87%'},
  {en: 'geraniol', ja: 'ゲラニオール', value:'5.71%'},
  {en: 'geranial', ja: 'ゲラニアール', value:'7.74%'},
  {en: 'neryl acetate', ja: 'ネリルアセテート', value:'0.04%'},
  {en: 'geranyl acetate', ja: 'ゲラニルアセテート', value:'4.30%'},
  {en: 'beta-elemene', ja: 'ベータ-エレメン', value:'0.19%'},
  {en: 'beta-caryophyllene', ja: 'ベータ-カリオフィレン', value:'1.71%'},
  {en: 'trans-isoeugenol', ja: 'トランス-イソオイゲノール', value:'0.18%'},
  {en: 'alpha-humulene', ja: 'アルファ-ヒュムレン', value:'0.18%'},
  {en: 'gamma-cadinene', ja: 'ガンマ-カジネン', value:'1.29%'},
  {en: 'delta-cadinene', ja: 'デルタ-カジネン', value:'0.18%'},
  {en: 'caryophyllene oxide', ja: 'カリオフィレンオキサイド', value:'0.37%'},
];

export const CymbopogonCitratus10 = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>
    
    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />
          
          <ProductTitle>レモングラス（ロット10）</ProductTitle>
          <ProductSubtitle>Cymbopogon citratus</ProductSubtitle>
          
          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date('2027-06-30T09:00:00.000Z').toLocaleDateString()}</Paragraph>
          
          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>ネパール</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>葉</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>水蒸気蒸留法</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>Cymbopogon citratus</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>イネ科</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>-</TableData>
              </TableRow>
            </tbody>
          </InfoTable>
          
          <SectionTitle>分析証明書</SectionTitle>
          
          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: Lemongrass 100% Organic ACO/USDA</li>
            <li>植物学名: Cymbopogon citratus</li>
          </List>
          
          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: 透明で流動性のある液体、黄色からオレンジ褐色</li>
            <li>香り: 新鮮な草のようなレモンの香り</li>
            <li>比重: 0.8790 〜 0.9070 @ 20°C</li>
            <li>屈折率: 1.4790 〜 1.4936 @ 20°C</li>
            <li>旋光度: +5.00 〜 -5.00</li>
          </List>
          
          <SubSectionTitle>ガスクロマトグラフ分析結果</SubSectionTitle>
          <InfoTable>
            <tbody>
              {data.map((item, index) => (
                <TableRow key={index}>
                  <TableDataLabel>{item.ja}</TableDataLabel>
                  <NumberData>{item.value}</NumberData>
                </TableRow>
              ))}
            </tbody>
          </InfoTable>
        </MainContent>
        
        <SideContent>
          <AcoContainer>
            <Aco />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);